module.exports = __webpack_public_path__ + "static/media/isi_perbidang_studi.4b772a8b.png";